





















import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class UTileSelect extends Vue {
  @Prop({ default: null })
  public value!: any;

  @Prop({ required: true })
  public items!: any;

  @Prop({ required: true })
  public valueFunc!: (item) => any;

  @Prop({ required: true })
  public srcFunc!: (item) => string;

  @Prop({ required: true })
  public labelFunc!: () => string;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public showAllWhenDisabled!: boolean;

  public get tiles() {
    if (!this.isDisabled || this.showAllWhenDisabled) return this.items;
    // Return only selected item
    return this.$_.filter(
      this.items,
      item => this.valueFunc(item) === this.value
    );
  }

  public onClick(value) {
    if (this.isDisabled) return;
    if (this.value === value) return;
    this.$emit("input", value);
  }
}
